import React from 'react';
import classnames from 'classnames';
import { formatValue } from '../helpers/data-helpers';
import { DataRowFormatType } from '../helpers/data-helpers';

export type InfoRowProps = {
    value?: unknown;
    format?: DataRowFormatType;
    style?: string;
    isSubheader?: boolean;
};
export type SingleItemInfoRowProps = InfoRowProps & {
    children?: React.ReactNode;
};

const styles = {
    default: {
        container: {},
        leftValue: {},
        rightValue: {},
    },
    row: {
        container: {},
        leftValue: {},
        rightValue: { textAlign: 'right' },
    },
    grouped: {
        container: {},
        leftValue: {},
        rightValue: {},
    },
    ungrouped: {
        container: {},
        leftValue: {},
        rightValue: {},
    },
};

export const InfoRow: React.FC<InfoRowProps> = ({ children, value, format, style = 'default', isSubheader }) => {
    return (
        <div
            className={classnames('row', { 'data-row-subheader': isSubheader })}
            style={styles[style].container}
        >
            <div
                className='columns'
                style={styles[style].leftValue}
            >
                {children}
            </div>
            <div
                className='columns'
                style={styles[style].rightValue}
            >
                {formatValue(value, format)}
            </div>
        </div>
    );
};
export const SingleItemInfoRow: React.FC<SingleItemInfoRowProps> = ({
    value,
    format,
    style = 'default',
    isSubheader,
    children,
}) => {
    return (
        <div
            className={classnames('row', { 'data-row-subheader': isSubheader })}
            style={styles[style].container}
        >
            <div
                className='columns'
                style={styles[style].leftValue}
            >
                {formatValue(value, format)}
            </div>
            {!!children && <div style={{ display: 'flex', flexDirection: 'row' }}>{children}</div>}
        </div>
    );
};
